import Link from 'next/link'
import { footerNavigations } from '../../helpers/utils'

const Sidebar = ({ categories }) => {
    return (
        <div>
            {/* Categories */}
            <div className="mb-8 p-4 bg-white shadow rounded-lg space-y-10">
                <div>
                    <h3 className="text-xl font-bold mb-4">Categories</h3>
                    {categories.map((category, idx) => (
                        <Link
                            key={idx}
                            href={`/podcasts/category/${category.slug}`}>
                            <a
                                key={idx}
                                className="text-gray-700 flex items-center justify-between">
                                <span>{category.name}</span>
                                <span className="bg-rtl-gradient h-8 w-8 items-center flex justify-center rounded-full text-white font-semibold">
                                    {category.totalPosts}
                                </span>
                            </a>
                        </Link>
                    ))}
                </div>
            </div>

            {/* Social Links */}
            <div className="p-4 bg-gradient-to-r from-orange-500 to-yellow-500 rounded-lg text-white">
                <h3 className="text-xl font-bold mb-4">Lets connect</h3>
                <p className="mb-4">
                    We specialize in providing real estate professionals with
                    precision-targeted direct mail solutions that are not only
                    effective but are crafted to maximize your return on
                    investment.
                </p>
                <div className="flex space-x-4">
                    {footerNavigations.social.map((item) => (
                        <a
                            target={item.target}
                            key={item.name}
                            href={item.href}
                            id={item?.id}
                            className="text-white hover:underline"
                            rel="noreferrer">
                            <span className="sr-only">{item.name}</span>
                            <item.icon className="h-6 w-6" aria-hidden="true" />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Sidebar
